module.exports = __webpack_public_path__ + "Statistics.png?f1a8f0724eac1f30ee4089bdb8545f63";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Solution/Case/Statistics.png
// module id = 179
// module chunks = 0